import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileBottomNav } from './MobileBottomNav';
import { OfflineBanner } from '../common/OfflineBanner';
import { GlobalToast } from '../common/GlobalToast';
import { ProjectProvider } from '../../context/ProjectProvider';
import { CallModals } from '../calls/CallModals';

export function MainLayout() {
  const location = useLocation();
  const isMessagesRoute = /^\/messages(\/[^/]+)?$/.test(location.pathname);

  return (
    <ProjectProvider>
      <GlobalToast />
      <OfflineBanner />
      <div className="flex h-dvh bg-slate-50">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block">
          <Sidebar />
        </div>

        <div
          className={`flex flex-1 flex-col min-w-0 lg:pb-0 ${
            isMessagesRoute
              ? 'pb-0'
              : 'pb-[calc(3rem+env(safe-area-inset-bottom))] sm:pb-[calc(3.5rem+env(safe-area-inset-bottom))]'
          }`}
        >
          <Header />
          <main
            className={`flex-1 min-w-0 shrink-0 overflow-y-auto lg:p-6 ${
              isMessagesRoute ? 'p-0' : 'p-1.5 sm:p-2'
            }`}
          >
            <Outlet />
          </main>
        </div>

        {/* Mobile Bottom Nav */}
        <MobileBottomNav />
      </div>

      <CallModals />
    </ProjectProvider>
  );
}
